<img [style.width.px]="width" class="animation-spin" src="assets/images/spinner.svg" alt="Spinner">
